import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CircularProgress from '@mui/material/CircularProgress';

interface Option {
  title: string;
  value: string;
  [key: string]: any;
}

interface MultiSelectProps {
  label?: string;
  placeholder?: string;
  value?: Option[];
  onChange?: (newValue: Option[]) => void;
  fetchOptions?: (query: string) => Promise<Option[]>;
  liClassName?: string;
  charThreshold?: number;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const testData = [ { title: 'The Shawshank Redemption', year: 1994 }, { title: 'The Godfather', year: 1972 }, { title: 'The Godfather: Part II', year: 1974 }, { title: 'The Dark Knight', year: 2008 }, { title: '12 Angry Men', year: 1957 }, { title: "Schindler's List", year: 1993 }, { title: 'Pulp Fiction', year: 1994 }, { title: 'The Lord of the Rings: The Return of the King', year: 2003, }, { title: 'The Good, the Bad and the Ugly', year: 1966 }, { title: 'Fight Club', year: 1999 }, { title: 'The Lord of the Rings: The Fellowship of the Ring', year: 2001, }, { title: 'Star Wars: Episode V - The Empire Strikes Back', year: 1980, }, { title: 'Forrest Gump', year: 1994 }, { title: 'Inception', year: 2010 }, { title: 'The Lord of the Rings: The Two Towers', year: 2002, }, { title: "One Flew Over the Cuckoo's Nest", year: 1975 }, { title: 'Goodfellas', year: 1990 }, { title: 'The Matrix', year: 1999 }, { title: 'Seven Samurai', year: 1954 }, { title: 'Star Wars: Episode IV - A New Hope', year: 1977, }, { title: 'City of God', year: 2002 }, { title: 'Se7en', year: 1995 }, { title: 'The Silence of the Lambs', year: 1991 }, { title: "It's a Wonderful Life", year: 1946 }, { title: 'Life Is Beautiful', year: 1997 }, { title: 'The Usual Suspects', year: 1995 }, { title: 'Léon: The Professional', year: 1994 }, { title: 'Spirited Away', year: 2001 }, { title: 'Saving Private Ryan', year: 1998 }, { title: 'Once Upon a Time in the West', year: 1968 }, { title: 'American History X', year: 1998 }, { title: 'Interstellar', year: 2014 },]

export default function MultiSelect({
  label = 'Select Items',
  placeholder = 'Search...',
  value = [],
  onChange,
  fetchOptions,
  liClassName = '',
  charThreshold = 3,
}: MultiSelectProps) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<Option[]>([]);
  const [loading, setLoading] = React.useState(false);
  const debounceTimeout = React.useRef<NodeJS.Timeout | null>(null);

  // React.useEffect(() => {
  //   console.log('options')
  //   console.log(options)
  // }, [options]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = async (_: any, newInputValue: string) => {
    clearTimeout(debounceTimeout.current);
    if (newInputValue.length >= charThreshold) {      
      debounceTimeout.current = setTimeout(async () => {
        if (fetchOptions) {
          setLoading(true);
          const data = await fetchOptions(newInputValue);
          console.log('data')
          console.log(data)
          setOptions(data);
          setLoading(false);
        }
      }, 400);  
    }
    else {
      return
    }
  };

  return (
    <Autocomplete
      multiple
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      // value={value}
      onChange={(_, newValue) => onChange?.(newValue)}
      onInputChange={handleInputChange}
      getOptionLabel={(option) => option.title}
      // isOptionEqualToValue={(option, val) => option.title === val.title}
      options={options}
      loading={loading}
      disableCloseOnSelect
      sx={{
        '& .MuiAutocomplete-endAdornment': {top: '27px'}
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps} className={liClassName} style={{fontSize: '14px', padding: '6px 0px'}}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.title}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          // label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
